<ng-template #sendToRetailerModal>
  <div id="sharePopup" class="card sharePopup">
    <div id="sharePopupHeader" class="modal-header">
      <div id="sharePopupClose" (click)="dismiss()" class="close_icon">
        <img class="sendPopup_info_icon" alt="close icon"/>
      </div>
    </div>
    <div id="sharePopupBody" class="modal-body">
       <h2 *ngIf="!isSendHeroTile"><span i18n="@@share.title">Send to {{contentName}}?</span></h2>
       <div id="sharePopupSuceess" class="send_to_heroTileSuccess" *ngIf="isSendHeroTile">
         <span class="success_img"></span>
       </div>
       <div id="sharePopupSuceessMsg" class="hero-tile-success-msg" *ngIf="isSendHeroTile">
         <span>{{heroTileSuccess}}</span>
       </div>
       <div id="sharePopupSuceessDesc" class="card_desc" *ngIf="!isSendHeroTile">
        <span>{{description}}</span>
       </div>
    </div>
    <div id="sharePopupFooter" class="modal-footer card-footer" *ngIf="!isSendHeroTile">
            <button type="button" (click)="dismiss()" class="btn btn-outline-primary gtmCancelDltContGrp">
              <span i18n="@@share.cancel">Cancel</span>
            </button>
            <button  type="button" class="btn btn-primary gtmDeleteContGrp" (click)="sendToRetailerHq()">
              <span i18n="@@share.send">Send {{buttonName}}</span>
            </button>
    </div>
  </div>
  </ng-template>
